export default "__VITE_ASSET__CPFefdjx__"